export const getBuildingOutputProgrammeMetrics = state => state?.buildingOutput?.programme_metrics
export const getBuildingGrossCommercialMetrics = state => state?.buildingOutput?.gross_commercial_metrics
export const getBuildingNetCommercialMetrics = state => state?.buildingOutput?.net_commercial_metrics
